import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ptBR from './pt-BR.json'

/**
 * Internacionalização com um idioma ativo.
 *
 * Ter só português não torna isto supérfluo: o ganho imediato não é tradução,
 * é o texto sair do componente. Centralizado, ele é revisável de uma vez,
 * mantém termo consistente entre telas e permite ao cliente ajustar redação
 * sem tocar em código — que é o mesmo princípio da parametrização.
 *
 * A chave é em INGLÊS por domínio (`comum.carregando`), o valor em português.
 * PRI-05 e o ADR 0001: o código fala inglês, a interface fala com o usuário.
 */
export const LOCALE = 'pt-BR'

void i18n.use(initReactI18next).init({
  resources: { 'pt-BR': { translation: ptBR } },
  lng: LOCALE,
  fallbackLng: LOCALE,
  interpolation: {
    // React já escapa; escapar de novo produziria `&amp;` na tela.
    escapeValue: false,
  },
})

export default i18n

/** Formatação por locale — nunca `toFixed` nem concatenação manual. */
export const formatar = {
  numero: (v: number, opcoes?: Intl.NumberFormatOptions) =>
    new Intl.NumberFormat(LOCALE, opcoes).format(v),

  /**
   * Dinheiro. Recebe string para não perder precisão no caminho —
   * `DAT-01` proíbe ponto flutuante para valor monetário, e isso vale
   * também no transporte até a tela.
   */
  moeda: (v: string | number) =>
    new Intl.NumberFormat(LOCALE, { style: 'currency', currency: 'BRL' }).format(
      typeof v === 'string' ? Number(v) : v,
    ),

  data: (v: string | Date, opcoes?: Intl.DateTimeFormatOptions) =>
    new Intl.DateTimeFormat(LOCALE, opcoes ?? {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(typeof v === 'string' ? new Date(v) : v),

  dataHora: (v: string | Date) =>
    new Intl.DateTimeFormat(LOCALE, {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    }).format(typeof v === 'string' ? new Date(v) : v),
}
